import { useMemo } from 'react';
import { AgeCategory } from '@mews-commander/data-access';
import { TableFilters, TableState } from '@optimus-web/core';
import { ProductCheckListTableColumn } from '../types';
import {
    ClaimedProductsBy,
    ProductCheckListFilterValues,
} from '../../../components/panels/ProductCheckListFilterFields/types';
import { getAgeCategoryIdentifier, getAgeCategoryTotalCellId } from '../../../utils/ageCategories';
import { ProductCheckListDataRow } from '../../../types';

export const useTableColumnsVisibility = (
    data: ProductCheckListDataRow[],
    tableState: TableState<ProductCheckListDataRow, TableFilters<ProductCheckListDataRow>>,
    filters: ProductCheckListFilterValues,
    ageCategories: AgeCategory[] | undefined
) => {
    const isSomeProductOrderVisible = isSomeProductOrderOnTablePage(data, tableState);

    return useMemo(() => {
        const noneAgeCategoryId = getAgeCategoryTotalCellId(getAgeCategoryIdentifier(null));

        let value = {
            [ProductCheckListTableColumn.Guests]: filters.displayedColumns.includes(ProductCheckListTableColumn.Guests),
            [ProductCheckListTableColumn.Owner]: filters.displayedColumns.includes(ProductCheckListTableColumn.Owner),
            [ProductCheckListTableColumn.Total]: filters.claimedProducts === ClaimedProductsBy.Total,
            [noneAgeCategoryId]: filters.claimedProducts === ClaimedProductsBy.AgeCategories,
        };

        if (ageCategories) {
            const visible = filters.claimedProducts === ClaimedProductsBy.AgeCategories;
            ageCategories.forEach((ageCategory) => {
                value = {
                    ...value,
                    [getAgeCategoryTotalCellId(getAgeCategoryIdentifier(ageCategory?.id))]: visible,
                    [noneAgeCategoryId]: visible && isSomeProductOrderVisible,
                };
            });
        }

        return value;
    }, [filters.claimedProducts, filters.displayedColumns, ageCategories, isSomeProductOrderVisible]);
};

const isSomeProductOrderOnTablePage = (
    data: ProductCheckListDataRow[],
    { pagination: { pageIndex, pageSize } }: TableState<ProductCheckListDataRow, TableFilters<ProductCheckListDataRow>>
): boolean => {
    const beginIndex = pageIndex * pageSize;
    const endIndex = Math.min((pageIndex + 1) * pageSize, data.length) - 1;

    for (let i = beginIndex; i < endIndex; i++) {
        if (data[i].productServiceOrder) {
            return true;
        }
    }

    return false;
};
